import { Fragment, FunctionComponent } from "react";
import { observer } from "mobx-react-lite";

import { ConfirmDialog } from "primereact/confirmdialog";
import { ConfirmPopup } from "primereact/confirmpopup";

import { CallableToast } from "./CallableToast/CallableToast";

const GlobalPrimeReactDefinitionsRaw: FunctionComponent = () => {
  return (
    <Fragment>
      <ConfirmPopup />

      <ConfirmDialog />

      <CallableToast />
    </Fragment>
  );
};

export const GlobalPrimeReactDefinitions = observer(GlobalPrimeReactDefinitionsRaw);
